export const ifElse = (predicate, truthy, falsy) => {
    const condition = typeof predicate === 'function' ? predicate() : predicate

    if (condition) {
        return truthy
    }

    return falsy
}
